export const PARTNER_SUBJECTS = [
    'PartnerDashboard',
    'PartnerLeads',
    'PartnerContacts',
    'PartnerMaterials',
    'PartnerNews'
];

//# sourceMappingURL=subjects.js.map